import WorkerData from "./WorkerData";

export default class WorkPeriod {
    public Id: string;
    public Name: string;
    public Date: string;
    public TipPin: number;
    public TipCash: number;
    public Workers: WorkerData[];

    constructor(id: string, name: string, date: string, tipPin: number, tipCash: number, workers: WorkerData[]) {
        this.Id = id;
        this.Name = name;
        this.Date = date;
        this.TipPin = tipPin;
        this.TipCash = tipCash;
        this.Workers = workers;
    }
}
